export function registerPwa(): void {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("./sw.js", {
      scope: "./",
      updateViaCache: "none",
    }).then((registration) => registration.update()).catch((error: unknown) => {
      console.error("Service Worker の登録に失敗しました。", error);
    });
  });
}
